import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

function changebg() {
    document.body.style.backgroundColor = "#EDEDED";
}

const BlockBack = () => {
    useEffect(() => {
        const handleBackButton = (event) => {
            event.preventDefault(); // Tarayıcı geri tuşunun varsayılan davranışını engelle
            window.history.pushState(null, null, window.location.href); // Yeni bir geçmiş girişi ekleyerek tarayıcı geçmişini güncelle
        };

        // Tarayıcı geri tuşuna basıldığında handleBackButton fonksiyonunu çağır
        window.addEventListener('popstate', handleBackButton);

        return () => {
            // Komponent kaldırıldığında event listener'ı temizle
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);
    return null;
};

export class PaymentFailed extends Component {

    componentDidMount() {
        $(document).ready(function () {
            $(".grecaptcha-badge").css("display", "none");
        });
    }
    componentWillUnmount() {
    }


    render() {
        // const [searchParams, setSearchParams] = useSearchParams();
        // var errorCode = searchParams.get("errorCode");
        // var errorMessage = searchParams.get("errorMessage"); 
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        var errorCode = params.get("code");
        var errorMessage = params.get("message");
        return (

            <>
                <BlockBack />
                <div className="container-fluid" onLoad={changebg()}>
                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            <div className="row no-gutters t-kutu t-kirmiziCizgi">
                                <div
                                    className="col bosluk backtop"
                                    style={{
                                        backgroundImage: 'url("/assets/img/backgrounds/back_top_turuncu.jpg")'
                                    }}  >
                                    <div className="row no-gutters pb-4">
                                        <div className="col-12 d-flex justify-content-center pb-2">
                                            <i className="t-icon-bubble1 t-icGenelBaslikIconKirmizi" />
                                        </div>
                                        <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslikKirmizi">
                                            TALEP ALINIRKEN HATA OLUŞTU
                                        </div>
                                        <div className="col-12 text-center t-icYaziPayment">
                                            {errorCode + " | " + errorMessage}

                                        </div>



                                    </div>
                                    <div>
                                        {errorCode === "V034" ? (
                                            <>
                                                <div className="row no-gutters d-flex justify-content-center">
                                                    <div className="text-center">
                                                        <p style={{ textShadow: '1px -1px #fff', fontSize: '14pt' }}>
                                                            Kartın belli bir tutarın üstünde online işlemlere izni olmayabilir.
                                                            <br></br>
                                                            Kartın o gün içinde belli sayıda online işlem adedine izni olabilir ve bu sayı aşılmış olabilir.
                                                            <br></br>
                                                            Eğer bir ön otorizasyon işlemi ise, kartın ön otorizasyon yetkisi olmayabilir.
                                                            <br></br>
                                                            Eğer saklı kart ile yapılan bir işlem işlem ise, kartın cvv'siz işlem yetkisi olmayabilir.
                                                            <br></br>
                                                            Karta özel Directory server tarafında Areq mesajı oluşmamamış olabilir.
                                                        </p>

                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className="col-auto renk" />
                            </div>
                        </div>
                    </div>
                    {/* <div className="row" style={{ height: 30 }} /> */}
                </div>
            </>
        )

    }
}



const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}
export default connect(mapStateToProps, mapDispatchToProps)(PaymentFailed);